import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const euro = (v) =>
  v === null || v === undefined || v === ""
    ? "Op aanvraag"
    : new Intl.NumberFormat("nl-BE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);

export const km = (v, unit = "km") =>
  v === null || v === undefined || v === ""
    ? "—"
    : `${new Intl.NumberFormat("nl-BE").format(v)} ${unit === "uren" ? "uren" : "km"}`;
